/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useRef } from 'react';
import CirclePicture from '../../../../../../../ui/CirclePicture';

const defaultEntryComponent = (props) => {
  const {
    mention,
    theme,
    isFocused,
    isManualFocused,
    searchValue, // eslint-disable-line no-unused-vars
    ...parentProps
  } = props;

  const entryRef = useRef(null);

  useEffect(() => {
    if (isFocused && isManualFocused) {
      if ('scrollIntoViewIfNeeded' in document.body) {
        entryRef && entryRef.current.scrollIntoViewIfNeeded(false);
      } else {
        entryRef && entryRef.current.scrollIntoView(false);
      }
    }
  }, [isFocused]);

  return (
    <div ref={entryRef} {...parentProps}>
      {mention.avatar ? <CirclePicture pictureUrl={mention.avatar} size={24.5} /> : null}
      <span css={theme.mentionSuggestionsEntryText}>{mention.name}</span>
    </div>
  );
};

export default defaultEntryComponent;
